import clsx from 'clsx';

type InfoMessageProps = {
    message: string;
    className?: string;
    darkMode?: boolean;
};

export const InfoMessage = ({ message, className = '', darkMode = false }: InfoMessageProps) => {
    return (
        <div className={clsx('r-flex r-items-center r-gap-1.5', darkMode && 'r-text-white', className)}>
            <span className="r-flex-shrink-0">
                <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                    <g fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="8" cy="8" r="7" />
                        <line x1="8" y1="7" x2="8" y2="11.5" />
                        <line x1="8" y1="4.5" x2="8" y2="4.5" strokeWidth="1.6" />
                    </g>
                </svg>
            </span>
            <span role="status" className="r-text-xs">
                {message}
            </span>
        </div>
    );
};
